var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useState } from "react";
import { Dialog } from "@headlessui/react";
import { useAuth0 } from "@auth0/auth0-react";
import { apiFetch, StyledButton, StyledButtonStyle, TextInput, } from "ee-react-components";
import { orchestratorUrl } from "./api";
export var ResponseFormDialog = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var open = _a.open, existing = _a.existing, onClose = _a.onClose, onSaved = _a.onSaved;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _j = useState((_b = existing === null || existing === void 0 ? void 0 : existing.name) !== null && _b !== void 0 ? _b : ""), name = _j[0], setName = _j[1];
    var _k = useState((_c = existing === null || existing === void 0 ? void 0 : existing.description) !== null && _c !== void 0 ? _c : ""), description = _k[0], setDescription = _k[1];
    var _l = useState((_d = existing === null || existing === void 0 ? void 0 : existing.duringPowerProfile) !== null && _d !== void 0 ? _d : { rechargeToTarget: true }), duringProfile = _l[0], setDuringProfile = _l[1];
    var _m = useState((_e = existing === null || existing === void 0 ? void 0 : existing.beforePowerProfile) !== null && _e !== void 0 ? _e : null), beforeProfile = _m[0], setBeforeProfile = _m[1];
    var _o = useState((_f = existing === null || existing === void 0 ? void 0 : existing.beforeOffsetMinutes) !== null && _f !== void 0 ? _f : 10), beforeOffset = _o[0], setBeforeOffset = _o[1];
    var _p = useState((_g = existing === null || existing === void 0 ? void 0 : existing.afterPowerProfile) !== null && _g !== void 0 ? _g : null), afterProfile = _p[0], setAfterProfile = _p[1];
    var _q = useState((_h = existing === null || existing === void 0 ? void 0 : existing.afterOffsetMinutes) !== null && _h !== void 0 ? _h : 10), afterOffset = _q[0], setAfterOffset = _q[1];
    var _r = useState(false), saving = _r[0], setSaving = _r[1];
    var _s = useState(null), error = _s[0], setError = _s[1];
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, getToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    if (!name.trim())
                        return [2 /*return*/, setError("Name is required.")];
                    if (beforeProfile && (!beforeOffset || beforeOffset <= 0))
                        return [2 /*return*/, setError("BEFORE offset must be greater than 0 minutes.")];
                    if (afterProfile && (!afterOffset || afterOffset <= 0))
                        return [2 /*return*/, setError("AFTER offset must be greater than 0 minutes.")];
                    payload = {
                        name: name,
                        description: description,
                        duringPowerProfile: duringProfile,
                        beforePowerProfile: beforeProfile,
                        beforeOffsetMinutes: beforeProfile ? beforeOffset : null,
                        afterPowerProfile: afterProfile,
                        afterOffsetMinutes: afterProfile ? afterOffset : null,
                    };
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    if (!existing) return [3 /*break*/, 3];
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/responses/").concat(existing.id), {
                            method: "PATCH",
                            body: payload,
                            callbacks: { getToken: getToken },
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/responses"), {
                        method: "POST",
                        body: payload,
                        callbacks: { getToken: getToken },
                    })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    onSaved();
                    onClose();
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 8];
                case 7:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Dialog, { open: open, onClose: onClose, className: "relative z-50" },
        React.createElement("div", { className: "fixed inset-0 bg-black/90", "aria-hidden": "true" }),
        React.createElement("div", { className: "fixed inset-0 flex items-center justify-center p-4" },
            React.createElement(Dialog.Panel, { className: "bg-black-1100 border border-black-700 shadow-2xl rounded-[16px] p-[32px] w-full max-w-[720px] max-h-[90vh] overflow-y-auto flex flex-col gap-y-[16px]" },
                React.createElement(Dialog.Title, { className: "text-white font-N6" }, existing ? "Edit Response" : "New Response"),
                React.createElement(Field, { label: "Name" },
                    React.createElement(TextInput, { value: name, onChange: function (e) { return setName(e.target.value); } })),
                React.createElement(Field, { label: "Description" },
                    React.createElement(TextInput, { value: description, onChange: function (e) { return setDescription(e.target.value); } })),
                React.createElement(PhaseSection, { title: "Before", profile: beforeProfile, onToggle: function () {
                        return setBeforeProfile(function (p) { return (p ? null : { rechargeToTarget: true }); });
                    }, onProfileChange: setBeforeProfile, offsetLabel: "Start offset before event (min)", offsetValue: beforeOffset, onOffsetChange: setBeforeOffset }),
                React.createElement(PhaseSection, { title: "During", profile: duringProfile, required: true, onProfileChange: function (p) {
                        return setDuringProfile(p !== null && p !== void 0 ? p : { rechargeToTarget: true });
                    } }),
                React.createElement(PhaseSection, { title: "After", profile: afterProfile, onToggle: function () {
                        return setAfterProfile(function (p) { return (p ? null : { rechargeToTarget: true }); });
                    }, onProfileChange: setAfterProfile, offsetLabel: "Duration after event (min)", offsetValue: afterOffset, onOffsetChange: setAfterOffset }),
                error && React.createElement("div", { className: "text-red font-N8" }, error),
                React.createElement("div", { className: "flex flex-row justify-end gap-x-[8px] mt-[8px]" },
                    React.createElement(StyledButton, { text: "Cancel", style: StyledButtonStyle.Gray, onClick: onClose }),
                    React.createElement(StyledButton, { text: saving ? "Saving..." : existing ? "Save" : "Create", onClick: save, disabled: saving }))))));
};
var PhaseSection = function (_a) {
    var _b, _c, _d, _e;
    var title = _a.title, profile = _a.profile, required = _a.required, onToggle = _a.onToggle, onProfileChange = _a.onProfileChange, offsetLabel = _a.offsetLabel, offsetValue = _a.offsetValue, onOffsetChange = _a.onOffsetChange;
    var set = useCallback(function (key, value) {
        var _a;
        if (!profile)
            return;
        onProfileChange(__assign(__assign({}, profile), (_a = {}, _a[key] = value, _a)));
    }, [profile, onProfileChange]);
    return (React.createElement("div", { className: "border border-black-800 rounded-[10px] p-[12px]" },
        React.createElement("div", { className: "flex flex-row items-center justify-between" },
            React.createElement("span", { className: "text-white font-N7 uppercase" }, title),
            !required && onToggle && (React.createElement(StyledButton, { text: profile ? "Remove" : "Add", style: profile ? StyledButtonStyle.Gray : StyledButtonStyle.Green, onClick: onToggle }))),
        profile && (React.createElement("div", { className: "grid grid-cols-2 gap-[8px] mt-[8px]" },
            offsetLabel && onOffsetChange && (React.createElement(NumField, { label: offsetLabel, value: offsetValue !== null && offsetValue !== void 0 ? offsetValue : null, onChange: function (v) { return onOffsetChange(v !== null && v !== void 0 ? v : 0); } })),
            React.createElement(NumField, { label: "Grid limit (kW)", value: (_b = profile.gridLimit) !== null && _b !== void 0 ? _b : null, onChange: function (v) { return set("gridLimit", v); } }),
            React.createElement(NumField, { label: "Max battery SOC (%)", value: (_c = profile.maxBatterySoc) !== null && _c !== void 0 ? _c : null, onChange: function (v) { return set("maxBatterySoc", v); } }),
            React.createElement(NumField, { label: "Grid-use-first above target SOC (kW)", value: (_d = profile.gridUseFirstAboveTargetSoc) !== null && _d !== void 0 ? _d : null, onChange: function (v) { return set("gridUseFirstAboveTargetSoc", v); } }),
            React.createElement(NumField, { label: "Grid-use-first below target SOC (kW)", value: (_e = profile.gridUseFirstBelowTargetSoc) !== null && _e !== void 0 ? _e : null, onChange: function (v) { return set("gridUseFirstBelowTargetSoc", v); } }),
            React.createElement("label", { className: "flex flex-row items-center gap-x-[8px] col-span-2" },
                React.createElement("input", { type: "checkbox", checked: profile.rechargeToTarget, onChange: function (e) { return set("rechargeToTarget", e.target.checked); } }),
                React.createElement("span", { className: "text-black-400 font-N8" }, "Recharge to target"))))));
};
var Field = function (_a) {
    var label = _a.label, children = _a.children;
    return (React.createElement("label", { className: "flex flex-col gap-y-[4px]" },
        React.createElement("span", { className: "text-black-400 font-N8" }, label),
        children));
};
var NumField = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange;
    return (React.createElement(Field, { label: label },
        React.createElement(TextInput, { type: "number", value: value == null ? "" : String(value), onChange: function (e) {
                var v = e.target.value.trim();
                onChange(v === "" ? null : Number(v));
            } })));
};
